import { Directive, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

@Directive({
  selector: 'ngx-mat-select-search[formControl], ngx-mat-select-search[formControlName]',
  standalone: false
})
export class TrimSelectSearchDirective implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(@Optional() @Self() private ngControl: NgControl) {}

  ngOnInit(): void {
    const control = this.ngControl?.control;
    if (!control) {
      return;
    }

    control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      if (typeof value === 'string' && value !== value.trim()) {
        // Defer setValue so the current valueChanges emission completes across all
        // subscribers before the trimmed value is re-emitted. Without this, a
        // synchronous patch creates a nested emission that finishes before the
        // original " foo" emission reaches the component's filter subscription,
        // causing the component to overwrite filteredItems with the untrimmed result.
        setTimeout(() => control.setValue(value.trim(), { emitEvent: true }));
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
